export default __webpack_public_path__ + "static/media/gallery-wip-head-pins_05.233fafb5.jpg";